import {supabase} from '../supabase/supabase';

const REPORTS_RPC='admin_get_pickup_problem_reports_1791004000000';
const UPDATE_RPC='admin_update_pickup_problem_status_1791004000000';

export const fetchAdminPickupProblemReports=async({
  status=null,
  problemType=null
}={})=>{
  const {data,error}=await supabase.rpc(REPORTS_RPC,{
    p_status:status || null,
    p_problem_type:problemType || null
  });

  if (error) throw error;

  return data || [];
};

export const updateAdminPickupProblemStatus=async(reportId,status)=>{
  const {data,error}=await supabase.rpc(UPDATE_RPC,{
    p_report_id:reportId,
    p_status:status
  });

  if (error) throw error;

  return data;
};